import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { useStateValue } from '../../state'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const NewOrgModal = props => {
  const [, dispatch] = useStateValue()
  const addNewOrg = async () => {
    try {
      let resp = await client.post(endpoints.addNewOrg(), {
        internalOrgName: newOrgName,
      })
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully added new organization."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
      dispatch({ type: 'updateTable', tableData: resp.data.organizations })
    } catch (err) {
      console.log(err)
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="There was an error trying to create a new organization."
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    } finally {
      props.toggle(!props.show)
    }
  }

  const [newOrgName, updateNewOrgName] = useState('')

  const handleOrgNameChange = e => {
    updateNewOrgName(e.target.value)
  }

  return (
    <Modal show={props.show} onHide={() => props.toggle(!props.show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Organization</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup controlId="orgName">
          <ControlLabel>New Organization Name</ControlLabel>
          <FormControl
            type="text"
            onChange={handleOrgNameChange}
            value={newOrgName}
          />
        </FormGroup>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => addNewOrg()}
        >
          <div className="far fa-plus fa-fw mr-2" /> Add Organization
        </div>
      </Modal.Body>
    </Modal>
  )
}

NewOrgModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
